import axios from 'axios'

import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import { jsonlint } from "@/utils/jsonlint"
import { Message, MessageBox } from 'element-ui'
import { clearLoginInfo } from '@/utils'
import moment from 'moment-timezone'
//axios.defaults.withCredentials = true;
// create an axios instance
const service = axios.create({
   //baseURL: '/proxyApi', // api 的 base_url
  baseURL:process.env.BASE_API,
  timeout: 1000*120, // request timeout
  transformResponse: [function (data) {
    return jsonlint.parse(data)
}]
})

// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    if (getToken()) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['token'] = getToken()
    }
    config.headers['loginType'] = "MachineSys"
    if (config.method === 'post') {
      if(!config.url.includes("/delete")){
        if(config.data!=undefined){
          config.data = {
            timeZone: moment.tz.guess(true),
           ...config.data
          }
        }else if(config.params!=undefined){
          config.params = {
            timeZone: moment.tz.guess(true),
           ...config.params
          }
        }
      
      }
     
      } else if (config.method === 'get') {
      config.params = {
        timeZone: moment.tz.guess(true),
       ...config.params
      }
      }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        console.log("token="+getToken())
        if(getToken()) {
            Message({
            message: "Login permission expired",
            type: 'error',
            duration: 5 * 1000
          })
        }
        store.dispatch('FedLogOut').then(() => {
          clearLoginInfo()
          router.push({ name: 'login' }) // 为了重新实例化vue-router对象 避免bug
        })
      }else{
        Message({
          message: res.message==undefined?res.msg:res.message,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(res)
    } else {
      return response.data
    }
  },
  error => {
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js